import React from 'react';
import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-50 py-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-4">
          <p className="text-gray-600 flex items-center justify-center space-x-2">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-pink-400 fill-pink-400" />
            <span>for a better tomorrow</span>
          </p>
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Rasika Godbole. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};